export default "__VITE_ASSET__f1b89f89__$_?nuxt_component=async__"